import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { createValidator, required } from 'utils/formValidations';
import { setError } from '@/actions';
import { applyPromotionalCode } from '@/actions/purchase';
import PromotionalCode from './PromotionalCode';

const validate = createValidator({
  promoCode: [required],
});

const mapStateToProps = (state) => {
  const { purchase } = state;

  return {
    token: purchase.get('token'),
  };
};

const mapDispatchToProps = (dispatch) => ({
  /**
   * Apply a promotional code to the purchase
   * @param {string} token - Purchase token
   * @param {string} code - Promotional code
   * @returns {Object} Dispatch action
   */
  onApplyPromo: (token, code) => dispatch(applyPromotionalCode(token, code)),

  /**
   * Set an error when applying a promotional code
   * @returns {Object} Dispatch action
   */
  onPromoCodeFail: () => dispatch(setError(null, 'write_a_promo_code', 'warning', false)),
});

const PromotionalCodeForm = reduxForm({
  form: 'promoCode',
  validate,
  onSubmitFail: (errors, dispatch) => {
    if (Object.keys(errors).length > 0) {
      dispatch(setError(null, 'write_a_promo_code', 'warning', false));
    }
  },
})(PromotionalCode);

export default connect(mapStateToProps, mapDispatchToProps)(PromotionalCodeForm);
